import React from 'react';
import { useBreadcrumb } from '@refinedev/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb as AntdBreadcrumb } from 'antd';

export const TranslatedBreadcrumbs = () => {
    const { breadcrumbs } = useBreadcrumb();
    const { t, i18n } = useTranslation();

    // Видаляємо "Home", якщо треба
    const filtered =
        breadcrumbs.length > 0 && breadcrumbs[0].label === 'dashboard'
            ? breadcrumbs.slice(1)
            : breadcrumbs;

    const translatePhrase = (str: string): string => {
        if (i18n.exists(`labels.${str}`)) {
            return t(`labels.${str}`);
        }
        return t(str);
    };

    return (
        <AntdBreadcrumb style={{ margin: '8px 10px' }}>
            {filtered.map((breadcrumb, index) => {
                const isLast = index === filtered.length - 1;
                const label = translatePhrase(breadcrumb.label);

                return (
                    <AntdBreadcrumb.Item key={breadcrumb.label}>
                        {isLast || !breadcrumb.href ? (
                            <span>{label}</span>
                        ) : (
                            <Link to={breadcrumb.href}>{label}</Link>
                        )}
                    </AntdBreadcrumb.Item>
                );
            })}
        </AntdBreadcrumb>
    );
};
